module.exports = __webpack_public_path__ + "img/sunscreenCRM.3f0749f5.jpg";